import { Node } from '../Node';

export const Video = Node.create({
  name: 'video',
  nodeType: 'video',
  group: 'block',
});
